import {
  Supertype,
  supertypeClass,
  property,
  remote,
  Remoteable,
  Persistable,
  amorphicStatic,
} from '@haventech/amorphic';
import {
  IsomorphicPersistent,
  Persistent,
  IsomorphicQuery,
  Query,
  Isomorphic,
  Serializable,
  AppController,
  SubController,
  Everything,
} from '@hit/amorphic-types';
import _ from 'lodash';
import { AnalyticsContainer } from './AnalyticsContainer';
import { Dimension } from './Dimension';
import { Customer } from './Customer';

@supertypeClass({ toClient: true, toServer: true })
export class Visitor extends Everything {
  @property()
  visitorId: string;

  @property({ type: Array, getType: () => AnalyticsContainer })
  analyticsContainers: Array<AnalyticsContainer> = [];

  @property()
  firstEventTime: Date;

  @property()
  lastEventTime: Date;

  @property({ type: Array, getType: () => Dimension })
  dimensions: Array<Dimension> = [];

  @property()
  channel: string;

  @property({ getType: () => Customer })
  customer: Customer;

  constructor() {
    super();
  }

  static new(visitorId: string, channel: string): Visitor {
    return new Visitor().init(visitorId, channel);
  }

  init(visitorId: string, channel: string): this {
    this.visitorId = visitorId;
    this.channel = channel;
    this.firstEventTime = new Date();
    this.lastEventTime = new Date();
    return this;
  }

  setTimeByEvent(start: Date, end: Date): void {
    if (start && (!this.firstEventTime || start.getTime() < this.firstEventTime.getTime())) {
      this.firstEventTime = start;
    }

    if (end && (!this.lastEventTime || end.getTime() > this.lastEventTime.getTime())) {
      this.lastEventTime = end;
    }
  }

  setCustomer(customer: Customer): void {
    this.customer = customer;
  }

  getDimension(name: string): Dimension {
    let dim = _.find(this.dimensions, function (d) {
      return d.name === name;
    });

    if (!dim) {
      dim = Dimension.new();
      dim.name = name;
      this.dimensions.push(dim);
    }

    return dim;
  }

  setDimension(name: string, value: string): void {
    this.getDimension(name).value = value;
  }
}
